var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99314 6.67311L6.67301 2.99381L5.46662 1.78743L3.78008 3.47396C3.75997 3.49411 3.73608 3.51009 3.70978 3.521C3.68348 3.53191 3.65529 3.53753 3.62682 3.53753C3.59835 3.53753 3.57016 3.53191 3.54386 3.521C3.51756 3.51009 3.49368 3.49411 3.47356 3.47396L3.16704 3.16744C3.08228 3.08267 3.08228 2.94541 3.16704 2.86092L4.85358 1.17439L3.93375 0.254292C3.59497 -0.0844906 3.04591 -0.0844906 2.70713 0.254292L0.254158 2.70725C-0.0843526 3.04604 -0.084626 3.59509 0.254158 3.93387L2.99314 6.67311ZM13.6152 3.47943C14.1282 2.96647 14.1279 2.13496 13.6152 1.622L12.3779 0.384719C11.865 -0.12824 11.0332 -0.12824 10.5199 0.384719L9.2616 1.64278L12.3569 4.73803L13.6152 3.47943ZM8.64282 2.26183L0.521849 10.3817L0.0088882 13.3194C-0.0602905 13.7156 0.284783 14.0607 0.681261 13.991L3.6193 13.4758L11.7381 5.35681L8.64282 2.26183ZM13.7459 10.0664L12.8261 9.14658L11.1395 10.8331C11.0548 10.9179 10.9175 10.9179 10.833 10.8331L10.5265 10.5266C10.442 10.4418 10.442 10.3046 10.5265 10.2201L12.213 8.53355L11.0061 7.32662L7.32624 11.0059L10.0663 13.7457C10.4051 14.0845 10.9542 14.0845 11.2929 13.7457L13.7459 11.293C14.0847 10.9542 14.0847 10.4052 13.7459 10.0664Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.ffe2e278384b239cb490018785ac66a0.svg";
export { ForwardRef as ReactComponent };